import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import router from '@/router'
import { Message } from 'element-ui'
import { getToken, getUser } from '@/utils/auth'




// 检测 Electron 注入的全局变量
export function isElectronEnv() {
    // Electron 会在渲染进程中注入 window.electron 或 window.require
    // 同时也可以检测 process 对象（Electron 渲染进程中存在）
    if (typeof window === 'undefined') return false;

    // 检测 Electron 特有的全局 API
    const hasElectronApi = !!window.electron ||
        (typeof window.require === 'function' &&
            typeof window.process === 'object' &&
            window.process.type === 'renderer');

    return hasElectronApi;
}


// 使用
export function getBaseURL() {
    let url = "";
    if (isElectronEnv()) {
        // Electron 网络配置
        // url = 'http://192.168.0.110'
        url = ""
    } else {
        // 纯前端逻辑
        url = '/api'
    }
    return url;
}




axios.defaults.baseURL = getBaseURL() //部署用这个

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;'
// axios.defaults.headers.common['Cache-Control'] = 'max-age=600, no-transform'

// axios.defaults.timeout = 1000 * 60 * 60 // 请求超时




// 添加请求拦截器
// const CancelToken = axios.CancelToken
// let cancel
const withOutLevelUrls = ["/uploadChat", "/Chat", "/uploadChat", "/Composition", "/showPaperNames"];

axios.interceptors.request.use(function (config) {
    config.headers.Authorization = getToken()
    config.headers['username'] = getUser() && getUser().phoneNumber
    if (config.url.includes("/signin")) {
        return config
    } else if (withOutLevelUrls.some(target => config.url.includes(target))) {
        config.headers.sessionId = store.state.sessionId
        // try {
        //     delete config.data.level

        // } catch (error) {
        //     console.log(error)
        // }
        return config

    }
    return config
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(
    function (response) {
        // 只有状态码 2xx 会进入这里，无需额外处理
        return Promise.resolve(response)
    },
    function (error) {
        // 错误处理：提取状态码和错误信息
        const status = error.response?.status
        const msg = error.response?.data?.message
        const currentHash = window.location.hash

        if (!status) {
            // 网络错误或请求未到达服务器（如跨域、超时）
            return Promise.reject(error)
        }

        // 处理认证相关错误（401 未授权，304 未修改，这里视同登录过期）
        if (status === 401 || status === 304) {
            if (currentHash.includes('login')) {
                Message({ message: msg || '登录信息有误，请检查', type: 'error' })
                return Promise.reject(error) // 阻止继续执行
            }
            Message({ message: msg || '登录过期，请重新登录', type: 'error' })
            store.commit("removeUser")
            store.commit("removeToken")
            store.commit("CLEAR_MESSAGE")
            router.push('/login')
            return Promise.reject(error)
        }

        // 处理 404 页面不存在（可保留或移除，此处保留）
        if (status === 404) {
            Message({ message: msg || '页面不存在', type: 'error' })
            return Promise.reject(error)
        }

        if (status === 423) {
            Message({ message: msg, type: 'error' })
            return Promise.reject(error)
        }

        if (status === 429) {
            Message({ message: msg, type: 'error' })
            return Promise.reject(error)
        }

        if (status === 500) {
            Message({
                message: status,
                message: msg || '网络错误，请稍后再试',
                type: 'error'
            })
            return Promise.reject(error)
        }

        // 其他所有错误（429、500 等）直接交给业务代码处理，不再弹出通用提示
        // 注意：下载请求通常设置 responseType: 'blob'，业务层会解析 Blob 中的错误信息
        return Promise.reject(error)
    }
)



function onFulfilled(response) {
    return response
}

function onRejected(error) {
   if (error.response) {
       return error.response.status
   } else if (error.request) {
       return error.request
   } else {
       return error.message
   }
}

export function get(url, params) {
    return axios.get(url, { params }).then(onFulfilled).catch(onRejected)
}

export function post(url, data) {
    return axios.post(url, data).then(onFulfilled).catch(onRejected)
}

//export function downloadPost(url, data) {
//    return axios.post(url, data, { responseType: 'blob' }).then(onFulfilled).catch(onRejected)
//}

export function downloadPost(url, data) {
    return axios.post(url, data, { responseType: 'blob' })
        .then(onFulfilled)
        .catch(error => {
            // 直接传递错误，不做任何返回值处理
            return Promise.reject(error);
        });
}

export function postQs(url, data) {
    return axios.post(url, qs.stringify(data)).then(onFulfilled).catch(onRejected)
}
// 动态获取上传文件地址
export function getApi() {
    return axios.defaults.baseURL
}

const config = {
    headers: {
        'Content-Type': 'application/octet-stream'
    }
}
export function streamPost(url, data, option) {
    return axios.post(url, data, option).then(onFulfilled).catch(onRejected)
}